import { render, staticRenderFns } from "./TagTopicTreeV2026.vue?vue&type=template&id=183ceeb8&scoped=true"
import script from "./TagTopicTreeV2026.vue?vue&type=script&lang=js"
export * from "./TagTopicTreeV2026.vue?vue&type=script&lang=js"
import style0 from "./TagTopicTreeV2026.vue?vue&type=style&index=0&id=183ceeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ceeb8",
  null
  
)

export default component.exports